// fetch ads
export const FETCH_ADS_REQUEST = 'advertisement/FETCH_ADS_REQUEST';
export const FETCH_ADS_SUCCESS = 'advertisement/FETCH_ADS_SUCCESS';
export const FETCH_ADS_FAILURE = 'advertisement/FETCH_ADS_FAILURE';
